import { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export function PrivateRoutes({children}){
    const {isAuth} =  useContext(AuthContext);

    if(isAuth===true){
        return <Link to="/" ></Link>
    }

    return children

}